import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import PageLoader from "../../../../../components/PageLoader";
import { globalProgram } from "../../../../../redux/global-community/action";
import { selectGlobalProgramListItems } from "../../../../../redux/global-community/selector";
import { programSubscriptions } from "../../../../../redux/program-subscriptions/action";
import Table from "../../../../../common/components/table-manager/v1.1/table";



const GlobalPrograms = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const GlobalProgramHubsItems = useSelector(selectGlobalProgramListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
       {field: 'DBNIEName', headerName: 'DBNIE Name'},
      {
        field: 'Name', headerName: 'Name', searchField: 'Name', filter: true,
        filterType: 'text'
      },
      {field: 'DBAName', headerName: 'DBAN Name'},
      {field: 'DBAName', headerName: 'DBAN Name'},
      {field: 'IsEnabled', headerName: 'Is Enable', cellRenderer: 'yesNoRenderer'},
      


    ]);
  }

  const handleSearch = (data: any) => { 

    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(globalProgram.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/global-programs/list`,
      entity: 'globalProgram', jsonData: {
         "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc"
      }
    }))
  }

  const handleReloadData = () => {
    dispatch(globalProgram.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/global-programs/list`,
      entity: 'globalProgram',
      jsonData: {
         "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc"
      }
    }))
  }
  const filterTypes = [{
    name: 'Text', value: "text"
  },
  {
    name: 'Number', value: "number"
  },
  {
    name: 'CheckBox', value: "checkbox"
  },
  {
    name: 'Date', value: "date"
  }
  ]
  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }

  const fetchPrograms = () => {
    dispatch(globalProgram.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/global-programs/list`,
      entity: 'globalProgram',
      jsonData: {
         "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc"
      }
    }))
  }


  const additionButtons: any = [

 
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,

      callback: () => handleReloadData(),
    },
  ];

  useEffect(() => {
    createColumnDefs()
    fetchPrograms()
  }, [pageData, pageSize])

const handleSubscribe = async (data: any) => {
    await dispatch(programSubscriptions.resetAction({ actionType: 'create' }));
    await dispatch(programSubscriptions.create({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/one-programs/subscribe`,
      entity: 'programSubscriptions',
      jsonData: {
       
        Records: [
          {
            Id: data.Id,
            
          }
        ]
      }
    })).then(() => {
      fetchPrograms();
    });
  };
  return (
    <>
      {GlobalProgramHubsItems?.isLoading ? <PageLoader /> :
      <Table
                    checkboxConfig={{
                        allowMultiSelect: true,
                        defaultSelectedIds: [],
                        isDisabled: false,
                        keyColumn: 'Id',
                    }}
          IsSubscribe={true} handleSubscribe={handleSubscribe}
          filterTypeLists={filterTypes}
          onSearch={handleSearch} columnData={columnDefs}
          rowData={GlobalProgramHubsItems?.result?.items} setPageData={setPageData}
          setPageSize={setPageSize} paginationData={GlobalProgramHubsItems?.result?.pagination}
          onEdit={handleEdit} additionButtons={additionButtons}
         headingName="Global Programs"
        />
      }
    </>
  );
};

export default GlobalPrograms;